import { Capacitor } from '@capacitor/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

/**
 * Take a photo using the native camera (Capacitor) or fall back to web.
 * Returns a File object ready for upload.
 */
export async function takeNativePhoto(): Promise<File> {
  if (!Capacitor.isNativePlatform()) {
    throw new Error('Native camera not available on web');
  }

  const photo = await Camera.getPhoto({
    quality: 85,
    resultType: CameraResultType.Uri,
    source: CameraSource.Camera,
    width: 1200,
    correctOrientation: true,
  });

  const response = await fetch(photo.webPath!);
  const blob = await response.blob();
  return new File([blob], `photo-${Date.now()}.jpg`, { type: 'image/jpeg' });
}

/**
 * Pick a photo from the device gallery.
 * Returns a File object ready for upload.
 */
export async function pickNativeGallery(): Promise<File> {
  if (!Capacitor.isNativePlatform()) {
    throw new Error('Native gallery not available on web');
  }

  const photo = await Camera.getPhoto({
    quality: 85,
    resultType: CameraResultType.Uri,
    source: CameraSource.Photos,
    width: 1200,
    correctOrientation: true,
  });

  const response = await fetch(photo.webPath!);
  const blob = await response.blob();
  return new File([blob], `photo-${Date.now()}.jpg`, { type: 'image/jpeg' });
}

/**
 * Check if native camera is available (running in Capacitor).
 */
export function hasNativeCamera(): boolean {
  return Capacitor.isNativePlatform();
}
